import React from 'react';
import { get } from 'lodash';
import Translate from '../../../core/translate/Translate';
import { withNotifications } from '../../common/notifications/NotificationsContext';
import { Dagger } from '../../common/notifications/NotificationsTrigger';

const KeyAttribute = ({
  notifications,
  attribute,
  retainDescriptionCasing,
}) => {
  const { disclosure, name, value } = attribute;
  const { disabled, show } = notifications;
  const symbol = !disabled && <Dagger className="key-attribute__dagger" />;

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    show(disclosure, event, null, true);
  };

  return (
    <div>
      {disclosure && !disabled ? (
        <div
          className="key-attribute__disclosure-container disclaimer"
          onClick={onClick}>
          {name}
          {symbol}
        </div>
      ) : (
        <div className="key-attribute__name">{name}</div>
      )}
      <div
        className={`key-attribute__description${
          retainDescriptionCasing
            ? ' key-attribute__description--no-transform'
            : ''
        }`}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </div>
  );
};

const KeyAttributes = ({ config, notifications }) => {
  const attributes = get(config, 'summary.keyAttributes');
  if (!attributes || attributes.length < 1) {
    return null;
  }
  const keyAttributes = attributes.map((attribute, index) => (
    <KeyAttribute
      key={`${attribute.name}_${index}`}
      attribute={attribute}
      notifications={notifications}
      retainDescriptionCasing={config?.driveType?.label === attribute?.value}
    />
  ));

  return (
    <div className="key-attributes">
      <div className="key-attributes__title">
        <Translate value="key.attributes.header.v3" />
      </div>
      <div className="key-attributes__grid">{keyAttributes}</div>
    </div>
  );
};

export default withNotifications(KeyAttributes);
